<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { useVModel } from "@vueuse/core";
import { cn } from "@/lib/utils";

const props = defineProps<{
  defaultValue?: string | number;
  modelValue?: string | number;
  class?: HTMLAttributes["class"];
}>();

const emits = defineEmits<{
  (e: "update:modelValue", payload: string | number): void;
}>();

const modelValue = useVModel(props, "modelValue", emits, {
  passive: true,
  defaultValue: props.defaultValue,
});
</script>

<template>
  <input
    v-model="modelValue"
    :class="
      cn(
        'flex h-9 w-full rounded border border-medium-tint   bg-transparent px-3 py-1 text-body-1 transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-medium disabled:bg-light  disabled:cursor-not-allowed ',
        props.class
      )
    "
  />
</template>
